import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE || '/backend/api/v1',
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gencrm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
